import { render, staticRenderFns } from "./SidebarSendEmail.vue?vue&type=template&id=2ad89661&"
import script from "./SidebarSendEmail.vue?vue&type=script&lang=js&"
export * from "./SidebarSendEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports